import React, { useEffect, useState } from "react";
import socketIOClient from "socket.io-client";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import UserPermission from "../UserPermission";
import api from "../../services/api";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ENDPOINT = process.env.REACT_APP_SERVER_PUSH_URL;

export default function Push() {

  // Permissão do usuário no sistema
  let userPermission = UserPermission();

  // eslint-disable-next-line
  const [token, setToken] = useState("123456");
  // const [notificationCustom, setNotificationCustom] = useState({ isOpen: false, message: '' });
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const [open, setOpen] = React.useState(false);
  const [vertical,] = React.useState('bottom');
  const [horizontal,] = React.useState('center');
  const [ocorrencia, setOcorrencia] = React.useState('');


  useEffect(() => {
    // Chamada ao servidor de push desativada (push.smartcitycanaadoscarajas.com)
    // if (ENDPOINT) {
    //   const socket = socketIOClient(ENDPOINT, {
    //     query: { token }
    //   });
    //
    //   if (userPermission) {
    //     api.get(`${userPermission}/areas`).then(response => {
    //       response.data.forEach(element => {
    //         socket.on(element.name, data => {
    //           setOcorrencia(data)
    //           setOpen(true)
    //         });
    //       });
    //     })
    //
    //   }
    //   return () => socket.disconnect();
    // }
  }, [token, userPermission]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          {ocorrencia}
        </Alert>
      </Snackbar>
    </>
  );
}
